import React from 'react';
import sortBy from 'lodash/sortBy';
import BasicTable from './BasicTable';
import { getFirstValidPrice, ensureDateNotUndefined } from '@bloomays-lib/utils.shared';
import isString from 'lodash/fp/isString';
import { useTheme } from '@mui/material/styles';

export interface PriceHistory {
  startDate?: Date | string;
  purchasePricePerDayWithoutTaxes: number;
  salePricePerDayWithoutTaxes: number;
  taxes: number;
  astreinteCoef?: number;
}

export interface PricingHistoryProps {
  prices?: PriceHistory[];
}
const PricingHistory = ({ prices }: PricingHistoryProps) => {
  const theme = useTheme();
  const today = new Date();
  const currentPrice = prices ? getFirstValidPrice(prices, today) : undefined;
  return (
    <BasicTable columns={['Début de validité', 'Achat', 'Vente', 'TVA', 'Astreinte']}>
      {prices &&
        sortBy(prices, [(p) => ensureDateNotUndefined(p.startDate).getTime()])
          .reverse()
          .map((p, i) => {
            const isCurrent = currentPrice === p;
            return (
              <tr
                key={`price-${i}`}
                style={isCurrent ? { background: theme.palette.red[20], color: 'white', fontWeight: 'bold' } : {}}
              >
                <td>{(isString(p.startDate) ? new Date(p.startDate) : p.startDate)?.toLocaleDateString() || ''}</td>
                <td>{`${p.purchasePricePerDayWithoutTaxes} €`}</td>
                <td>{`${p.salePricePerDayWithoutTaxes} €`}</td>
                <td>{`${p.taxes} %`}</td>
                <td>{`${(p.astreinteCoef || 2) * 100} %`}</td>
              </tr>
            );
          })}
    </BasicTable>
  ) as React.ReactNode;
};

export default PricingHistory;
